var App = App || {};

App.SolutionsFinder = (function ($) {
    "use strict";

    let isSlickInitialized = false;

    function init() {

        initSlickTabs();
        $(window).on("resize", function () {
            initSlickTabs();
            updateNavLinkHeight();
        });
    }

  

    function initSlickTabs() {
        const $navPills = $(".solutions-wrapper .nav-pills");

        if ($(window).width() < 992) {
            if (!isSlickInitialized) {
                $navPills.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
                    nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-arrow-right"></i></button>',
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: { slidesToShow: 3 }
                        },
                    ]
                });

                isSlickInitialized = true;

                // Check arrow visibility after initialization
                checkArrowVisibility();
                updateNavLinkHeight();

                // Add event listener for arrow visibility on slide change
                $navPills.on("afterChange", function () {
                    checkArrowVisibility();
                    updateNavLinkHeight();
                });
                $(window).on("resize", function () {
                    updateNavLinkHeight();
                });
            }
        } else {
            if (isSlickInitialized) {
                $navPills.slick("unslick");
                isSlickInitialized = false;

                // Restore Bootstrap default styles
                $navPills.removeAttr("style")
                    .removeClass("slick-initialized slick-slider slick-dotted");

                $(".solutions-wrapper .nav-item").removeAttr("style");
                $(".solutions-wrapper .nav-link").removeAttr("style");

                // Remove Slick's extra markup
                $(".solutions-wrapper .slick-track, .solutions-wrapper .slick-list").children().unwrap();
            }
        }
    }

    function checkArrowVisibility() {
        const $navPills = $(".solutions-wrapper .nav-pills");

        if ($navPills.slick("slickCurrentSlide") === 0) {
            $(".slick-prev").hide();
        } else {
            $(".slick-prev").show();
        }

        if ($navPills.slick("slickCurrentSlide") === $navPills.slick("getSlick").slideCount - $navPills.slick("getSlick").options.slidesToShow) {
            $(".slick-next").hide();
        } else {
            $(".slick-next").show();
        }
    }

   
    function updateNavLinkHeight() {
        if ($(window).width() < 992) {
            let maxHeight = 0;
            $(".solutions-wrapper .nav-link").css("height", "");

            $(".solutions-wrapper .nav-link").each(function () {
                let thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            $(".solutions-wrapper .nav-link").css("height", maxHeight + "px"); 
        } else {
            $(".solutions-wrapper .nav-link").css("height", ""); 
        }
    }



    return {
        init: init
    }
})(jQuery);

$(function () {
    App.SolutionsFinder.init();
});